import React from 'react';
import './ChatSimulation.css';
import { FaLock } from 'react-icons/fa';

function ChatSimulation() {
  return (
    <div className="phone-stage">
      <div className="phone">
        <div className="phone-notch" />
        <div className="chat-head">
          <div className="chat-avatar">JM</div>
          <div>
            <div className="chat-name">Jess M.</div>
            <div className="chat-sub">
              <FaLock size={9} /> Encrypted chat
            </div>
          </div>
        </div>
        <div className="chat-body">
          <div className="msg in m1">hey, you free to call later?</div>
          <div className="msg out m2">yeah! after 6 works</div>
          <div className="msg in m3">perfect, I'll ring you then</div>
          <div className="typing">
            <i></i><i></i><i></i>
          </div>
          <div className="msg out m4">sounds good 👍</div>
          <div className="lock-tag">
            <FaLock size={9} /> Message secured end-to-end
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChatSimulation;